export const useMapDialogStore = defineStore('mapDialog', () => {
  const mapCenterCoordinates = ref<string>();
  const mapCenterAddress = ref<Address>();
  const mapOtherAddresses = ref<Address[]>();
  const mapDialogOpen = ref(false);

  watch(mapDialogOpen, mapDialogIsOpen => {
    if (!mapDialogIsOpen) {
      mapCenterAddress.value = undefined;
      mapCenterCoordinates.value = undefined;
    }
  });

  /**
   * Opens the map dialog and sets the map data
   *
   * @param imageSrc
   */
  const openMapDialog = (centerCoordinates?: string, centerAddress?: Address, otherAddresses?: Address[]) => {
    if (centerCoordinates) {
      mapCenterCoordinates.value = centerCoordinates;
    }
    mapCenterAddress.value = centerAddress;
    mapOtherAddresses.value = otherAddresses;
    mapDialogOpen.value = true;
  };

  return {
    mapCenterCoordinates,
    mapCenterAddress,
    mapOtherAddresses,
    mapDialogOpen,
    openMapDialog,
  };
});
